import authentication from "@irati/auth"

// Docs: "/docs/web/devToggles.md"
class DevToggles {
  /**
   * @description: Rolling out VR experience for Wellness (WEL-1763)
   */
  showWellnessVRExample() {
    const allowedDomainsForTesting = ["qa-business", "test-staging-business", "test-prod-business"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showHomePageFestiveCard() {
    const allowedDomainsForTesting = ["kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn", "festive"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showNativeGroupRecognition() {
    const allowedDomainsForTesting = ["group-recognition", "kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showNativeMyGreetingCards() {
    const allowedDomainsForTesting = ["group-recognition", "kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showMySavings() {
    const allowedDomainsForTesting = ["kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn", "home"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showYourPerkboxStory() {
    const allowedDomainsForTesting = ["recognition"]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
  showSSOFeatureFlag() {
    const allowedDomainsForTesting = [
      "home",
      "testaccount1",
      "testaccount2",
      "testaccount3",
      "testaccount4",
      "testaccount5",
      "testaccount6",
      "testaccount12",
      "abcdefg",
      "test-account-self-renewal-training",
      "test-account-upsell",
      "test-account-renew-integ-w-disc"
    ]
    return allowedDomainsForTesting.includes(authentication.business().subdomain)
  }
}

export default new DevToggles()
